import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-substantiation",
    prompt: "We've selected the Card Swipe Guarantee as your default substantiation method, which will eliminate the need for your participants to submit documentation for card transactions. For more information about the Card Swipe Guarantee, click the ? icon on the right-hand side of this panel.",
    briefDescription: 'Substantiation',
    beforeLoad: async (component, guidanceItem) => {
        await component.$store.dispatch("employer/load", {employerId: guidanceItem.employerId, refreshSameEmployer: true});
    },
    openAction: { 
        text: "View Substantiation Method",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/general`,
        row: "Substantiation"
    },
    completeAction: { 
    }
});



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-substantiation.js